import { Alert, CenterScreen, EmptyContent, HorizontalStack, ShowIf, Spinner } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import { AutomaticRedirectButton } from '@ztechapps/webui.button'
import type { ReactNode } from 'react'
import React from 'react'

export type PaymentStatusContainerProps = {
  loading: boolean
  orderName: string
  redirecTo: string
  message: ReactNode
  subMessage: ReactNode
  icon: ReactNode
  alertType: string
}

export const PaymentStatusContainer = ({
  loading,
  orderName,
  redirecTo,
  message,
  subMessage,
  icon,
  alertType,
}: PaymentStatusContainerProps) => {
  return (
    <CenterScreen minHeight={80}>
      <HorizontalStack gap={4} className="justify-content-between     ">
        <Stack gap={5}>
          <Alert type={alertType}>
            <ShowIf condition={loading}>
              <div className="text-center">
                <Spinner /> Please wait while we are loading your data
              </div>
            </ShowIf>
            <ShowIf condition={!loading}>
              <EmptyContent
                icon={icon}
                message={message}
                subMessage={<h5>{subMessage}</h5>}
                action={<AutomaticRedirectButton title={`Back to order [${orderName}]`} redirectTo={redirecTo} />}
              />
            </ShowIf>
          </Alert>
        </Stack>
      </HorizontalStack>
    </CenterScreen>
  )
}
